module.exports = __webpack_public_path__ + "media/images/mastercard-3a55b54780eb7997b70cef503c7da0a4.svg";